import { createContext } from 'react';
import { EventBus } from '../util/EventBus';
import { AnalyticsState } from './AnalyticsState';
import { TrackingData } from './TrackingData';
import { TrackingEvent } from './TrackingEvent';

export type AnalyticsContext = {
  state: AnalyticsState;
  bus: EventBus<AnalyticsEvent>;
};

export interface AnalyticsEvent {
  data: TrackingData;
  name: TrackingEvent;
}

export const defaultContext: AnalyticsContext = {
  state: new AnalyticsState(),
  bus: new EventBus(),
};

export const AnalyticsContext = createContext(defaultContext);
